var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
function walkTree(node, predicate, fn, path, accc) {
    if (path === void 0) { path = ''; }
    var acc = accc || __assign({}, node);
    var newNode = node;
    if (predicate(node)) {
        newNode = fn(node);
        if (path === '')
            return newNode;
    }
    lodash_1.set(acc, path === '' ? '.' : path, newNode);
    if (node.children !== undefined) {
        node.children.forEach(function (child, i) {
            walkTree(child, predicate, fn, path + "children[" + i + "]", acc);
        });
    }
    return acc;
}
exports.walkTree = walkTree;
